import { render, staticRenderFns } from "./addressConfirmModal.vue?vue&type=template&id=84dadcb8&scoped=true"
import script from "./addressConfirmModal.vue?vue&type=script&lang=js"
export * from "./addressConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./addressConfirmModal.vue?vue&type=style&index=0&id=84dadcb8&prod&lang=scss"
import style1 from "./addressConfirmModal.vue?vue&type=style&index=1&id=84dadcb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dadcb8",
  null
  
)

export default component.exports